<template>
  <div>
    <button @click="send" class="btn btn-info mt-3 mw">
      {{ "next" | setText("Далее") }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "../../../plugins/functions";

export default {
  watch: {},
  components: {
    informator: () => import("./Informator"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  created() {
    this.data["loan_id"] = this.value["loan_id"];
  },
  name: "filter",
  mounted() {},
  methods: {
    send() {
      this.$loading(true);
      let contentType = "multipart/form-data";
      let data = this.data;
      let link = `send-data/send-sms`;

      if (this.resendData == true) {
        contentType = "application/json";
        link = `resend-data`;
        data = {
          job_id: this.job_id,
          log_id: this.log_id,
        };
      }

      this.$http({
        url: `${this.partner["endpoint_url"]}${link}`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,

          "Content-Type": contentType,
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: data,
      })
        .then((response) => {
          if (response.data) {
            {
              if (response.data.OTP_session) {
                this.createTransaction({
                  step: "need-cancel",
                  pre_api_result: JSON.stringify(response.data),
                });
                this.$emit("setStep", "confirm-card-otp");
              } else {
                this.createTransaction({
                  step: "customer-data",
                  pre_api_result: JSON.stringify(response.data),
                });
                this.$emit("setStep", "customer-data");
              }

              this.$emit("input", {
                ...this.value,
                ...response.data,
              });
            }
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      videoStream: null,
      videoElement: null,
      canvasElement: null,
      resendData: false,

      job_id: null,
      log_id: null,

      data: {
        // photo: null,
        loan_id: null,
        // code: null,
      },
    };
  },
  beforeDestroy() {},
};
</script>

